/**
 * Nombre de RESPALDO de cada catálogo.
 *
 * El nombre que manda es la etiqueta del módulo (tabla `modules`, editable en
 * la pantalla de Módulos): la usan la tarjeta del menú, el título de la
 * pantalla, el menú lateral y el título del Excel. Este mapa solo se usa si un
 * módulo no tiene etiqueta.
 *
 * La llave es el último segmento de la ruta (`/catalogues/<llave>`).
 */
export const CATALOGUE_TITLES: Record<string, string> = {
  accessories:                     'Accesorios',
  affiliate:                       'Filiales',
  affiliates:                      'Filiales',
  brands:                          'Marcas',
  clients:                         'Clientes',
  courses:                         'Cursos',
  doctors:                         'Médicos',
  equipments:                      'Equipos',
  fixedAssetConfigurations:        'Configuraciones de activo fijo',
  fixedAssetServiceConfigurations: 'Configuraciones de servicio',
  hospitalServices:                'Servicios hospitalarios',
  institutions:                    'Instituciones',
  instrumentals:                   'Instrumental',
  kits:                            'Kits',
  manufacturers:                   'Fabricantes',
  measurementInstruments:          'Instrumentos de medición',
  measurementUnits:                'Unidades de medida',
  medicalGasTanks:                 'Tanques de gas medicinal',
  paymentMethods:                  'Métodos de pago',
  peripheralEquipment:             'Equipo periférico',
  places:                          'Ubicaciones',
  procedures:                      'Procedimientos',
  products:                        'Insumos',
  spareParts:                      'Refacciones',
  specialties:                     'Especialidades',
  substitutes:                     'Insumos sustitutos',
  suppliers:                       'Proveedores',
  supplies:                        'Insumos',
  taxRegimes:                      'Regímenes fiscales',
  warehouses:                      'Lockers',
};

/** Último segmento de `/catalogues/<llave>` (sin query ni hash). */
export function catalogueKey(route: string | undefined | null): string {
  const parts = String(route ?? '').split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '').split('/');
  return parts[parts.length - 1] ?? '';
}

/** Nombre del catálogo de una ruta; `fallback` si no está en el mapa. */
export function catalogueTitle(route: string | undefined | null, fallback = ''): string {
  return CATALOGUE_TITLES[catalogueKey(route)] ?? fallback;
}
